import { render, staticRenderFns } from "./othersTable.vue?vue&type=template&id=eb34675e&"
import script from "./othersTable.vue?vue&type=script&lang=js&"
export * from "./othersTable.vue?vue&type=script&lang=js&"
import style0 from "./othersTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports